import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {CourseService} from "@app/@core/services/course.service";
import {Observable} from "rxjs";
import {SelectItemGroup} from "primeng/api";
import {map} from "rxjs/operators";
import {PackageInfoService} from "@app/@core/services/package-info.service";
import {LeisureShopService} from "@app/@core/services/leisure-shop.service";


interface KV {
    id?: string;
    name?: string;
}

@Component({
    selector: 'app-shop-select',
    template: `
        <ng-container *ngIf="multi;else templateSingle">
            <p-multiSelect [options]="groupedOptions$| async"
                           [(ngModel)]="shopId"
                           [group]="true"
                           [styleClass]="styleClass"
                           (ngModelChange)="changed($event)"
                           placeholder="Select a Shop"
                           selectedItemsLabel="{0} items selected">
            </p-multiSelect>
        </ng-container>

        <ng-template #templateSingle>
            <p-dropdown [options]="groupedOptions$| async"
                        [filter]="true"
                        [(ngModel)]="shopId"
                        [showClear]="true"
                        [styleClass]="styleClass"
                        (ngModelChange)="changed($event)"
                        [group]="true"
                        placeholder="Select a Shop">
            </p-dropdown>
        </ng-template>

        <ng-template let-group pTemplate="group">
            <div class="text-center">
                <span class="text-primary">-- {{ group.label }} --</span>
            </div>
        </ng-template>
    `,
    styles: []
})

export class ShopSelectComponent implements OnInit {
    @Input() shopId: string | string[];
    @Input() multi = false;
    @Input() openOnly = false;
    @Input() styleClass: string;
    @Output() onChanged = new EventEmitter<KV | KV[]>();
    @Output() shopIdChange = new EventEmitter<string | string[]>();
    groupedOptions$: Observable<SelectItemGroup[]>;

    constructor(private packageService: PackageInfoService,
                private leisureShopService: LeisureShopService,) {
    }

    ngOnInit(): void {
        if (this.openOnly) {
            this.groupedOptions$ = this.leisureShopService.groupedOptions$;
        } else {
            this.groupedOptions$ = this.leisureShopService.groupedOptions$.pipe(
                map((groupedOptions: SelectItemGroup[]) => {
                    return groupedOptions.filter(groupedOption => groupedOption.label === 'OPEN');
                })
            );
        }
    }


    changed($event: any) {
        this.shopIdChange.emit(this.shopId);

        if (this.shopId) {
            if (Array.isArray(this.shopId)) {
                const kvs = this.shopId.map((id: string) => ({id, name: this.leisureShopService.getName(id)} as KV));
                this.onChanged.emit(kvs);
            } else {
                this.onChanged.emit({id: this.shopId, name: this.leisureShopService.getName(this.shopId)});
                this.onChanged.emit({id: this.shopId, name: this.leisureShopService.getName(this.shopId)});
            }
        } else {
            console.log('shopId3');
            this.onChanged.emit({});
        }
    }
}
